import Image from 'app/Components/Shared/Image/image';
import React, {useCallback} from 'react';
import Config from '../../../../../Config';
import {text} from '../../constants';
import {prepareSameWindowUrlWithNavigateTo} from 'app/utilities/StringHelpers/StringHelpers';
import {checkLoginData} from 'app/Components/Page/SelfCarePage/Utilities';

const DisconnectUser = ({context, authentication}) => {
  const isUserConnected = checkLoginData(authentication.loginData);

  const handleOnClick = useCallback(() => {
    prepareSameWindowUrlWithNavigateTo(Config.logoutPage, context);
  }, [context]);

  return (
    <>
      <div className='self-care-disconnect-border'>
        {isUserConnected && (
          <div className='self-care-disconnect' onClick={handleOnClick}>
            <span className='img-location'>{text.disconnectUser}</span>
            <span>
              <Image src={require('../../images/log_out_mobile.svg')} />
            </span>
          </div>
        )}
      </div>
    </>
  );
};

export default DisconnectUser;
